interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  icon?: string;
}

export default function PageHeader({ eyebrow, title, description, icon }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            {icon && <i className={icon} />}
            {eyebrow}
          </span>
        )}
        <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {description && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}